export const ENTITY = "MANDATORY_REQUIREMENT";
